import React from 'react';
import { Zap, ShieldCheck, Wallet } from 'lucide-react';
export function ValueProps() {
  const features = [{
    icon: <Wallet className="w-12 h-12 text-slate-600" data-id="element-121" />,
    title: 'NO FEES OR COMMISSIONS',
    description: 'Keep more of your money. We pay all closing costs and charge zero commissions. What we offer is what you get.'
  }, {
    icon: <Zap className="w-12 h-12 text-slate-600" data-id="element-122" />,
    title: 'ANY CONDITION',
    description: 'Fire damage? Hoarder house? Leaking roof? We buy it all as-is. No repairs, no cleaning, no stress.'
  }, {
    icon: <ShieldCheck className="w-12 h-12 text-slate-600" data-id="element-123" />,
    title: 'GUARANTEED CLOSING',
    description: 'We use our own cash, so there are no bank approvals to wait for. We close on your timeline, as fast as 7 days.'
  }];
  return <section className="relative w-full bg-white py-32 px-6 lg:px-8" data-id="element-124">
      {/* Diagonal Top Divider */}
      <div className="absolute top-0 left-0 w-full h-24 bg-gray-50" style={{
      clipPath: 'polygon(0 0, 100% 0, 0 100%)'
    }} data-id="element-125"></div>

      <div className="max-w-7xl mx-auto relative z-10 mt-12" data-id="element-126">
        <div className="mb-20" data-id="element-127">
          <h2 className="text-4xl md:text-6xl font-black text-black mb-6 uppercase tracking-tighter" data-id="element-128">
            Why Sell To Us?
          </h2>
          <div className="w-24 h-2 bg-slate-600" data-id="element-129"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-130">
          {features.map((feature, index) => <div key={index} className="group relative bg-white border border-gray-200 p-8 hover:border-slate-600 transition-colors duration-300" data-id="element-131">
              <div className="absolute top-0 right-0 w-16 h-16 bg-slate-600/5 group-hover:bg-slate-600 transition-colors duration-300" style={{
            clipPath: 'polygon(100% 0, 0 0, 100% 100%)'
          }} data-id="element-132"></div>

              <div className="mb-8 p-4 border-2 border-slate-600 inline-block" data-id="element-133">
                {feature.icon}
              </div>

              <h3 className="text-2xl font-black text-black mb-4 uppercase tracking-wide" data-id="element-134">
                {feature.title}
              </h3>

              <p className="text-lg text-gray-700 font-medium leading-relaxed" data-id="element-135">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}